import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import ContentHeader from '@zenbusiness/zui/ContentHeader';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './ReferAFriendCard.styles';

const ReferAFriendCard = () => {
  const { formatMessage: fm } = useIntl();

  const destination = 'http://share.zenbusiness.com/evergreenwelcome7s16';

  return (
    <Styled.Root>
      <Styled.Image
        alt={fm({ id: 'dashboard.carousel.card.referAFriend.imageAlt' })}
        src="/s2/raster/market-pottery-laugh.jpg"
      />
      <Styled.CardContent>
        <ContentHeader
          title={<Text size="md" weight="medium" color="primary"><FormattedMessage id="dashboard.carousel.card.referAFriend.title" /></Text>}
          subtitle={<Text size="sm" weight="regular" color="secondary"><FormattedMessage id="dashboard.carousel.card.referAFriend.subTitle" /></Text>}
        >
          <Styled.CardButton
            clickstreamProps={{
              elementName: 'carousel_link',
              elementText: 'refer_a_friend',
              destination
            }}
            color="secondary"
            href={destination}
            size="sm"
            target="_blank"
          >
            <FormattedMessage id="dashboard.carousel.card.referAFriend.button" />
          </Styled.CardButton>
        </ContentHeader>
      </Styled.CardContent>

    </Styled.Root>
  );
};

export default ReferAFriendCard;
